import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const ImportProductionApi = createApi({
  reducerPath: "ImportProductionApi",
  baseQuery,
  tagTypes: ["ImportProductionDetails"],
  endpoints: (builder) => ({

    getImportProductionDetailsById: builder.query({
      query: ({id}) => `/import/product/productionDetails/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];

        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];

        // Add `id` field from exportEntityId
        return normalized.map((item) => ({
          ...item,
          id: item.importProductionDetailsId,
        }));
      },
      providesTags: ["ImportProductionDetails"],
    }),

    createImportProductionDetail: builder.mutation({
      query: ({id , ...data}) => ({
        url: `/import/product/productionDetails/${id}`,
        method: "PUT", 
        body: { importProductionDetails:data },
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
        
      }),
      invalidatesTags: ["ImportProductionDetails"],
    }),


    updateImportProductionDetail: builder.mutation({
      query: ({ id ,subId, ...data  }) => ({
        url: `/import/product/productionDetails/${id}/${subId}`,
        method: "PUT",
        body: { importProductionDetails:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportProductionDetails"],
    }),

    deleteImportProductionDetail: builder.mutation({
      query: ({id}) => ({
        url: `/import/product/productionDetails/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportProductionDetails"],
    }),

  }),
});

export const {
  useLazyGetImportProductionDetailsByIdQuery,
  useCreateImportProductionDetailMutation,
  useUpdateImportProductionDetailMutation,
  useDeleteImportProductionDetailMutation,
} = ImportProductionApi;
